import getIorderHeaders from '@/libs/iOrderHeaders'

export default {
	initJourney (state) {
		state.requiredSalesData = {
			siteId:       null,
			salesAreaId:  null,
			foodMenuId:   null,
			drinksMenuId: null,
			serviceId:    null,
			tableNumber:  null
		};
		state.basket = {
			lines: [],
			voucherLines: []
		};
		state.tables = [];
		state.validVoucherApplied = null;
		state.iOrderLocation = null;
		state.error = { heading: null, message: null };
		state.menus = {
			food: {
				display: {
					displayGroups: []
				}
			},
			drinks: {
				display: {
					displayGroups: []
				}
			}
		},
		state.lineItemsAddedCount = 0;

		state.config = getIorderHeaders(state.env, 'COAT');
	},
	addLineItemToBasket (state, { lineItem }) {
		state.basket.lines.push(lineItem);
		state.lineItemsAddedCount++;
	},
	addUnavailableFlag (state, { basketItemIndex }) {
		state.basket.lines[basketItemIndex].unavailable = true;
	},
	addVoucherCodeToBasket (state, { voucherCode }) {
		state.basket.voucherLines.push({ voucherCode });
	},
	clearBasketMessages (state) {
		state.basket.lines.forEach((line) => {
			if (line.messages) line.messages = [];
		});
	},
	clearVoucherLines (state) {
		state.basket.voucherLines = [];
	},
	decrementBasketItem (state, { basketItemIndex }) {
		state.basket.lines[basketItemIndex].quantity --;
	},
	editBasketChoices (state, { basketIndex, choicesArray }) {
		state.basket.lines[basketIndex].choiceLines = choicesArray;
	},
	incrementBasketItem (state, { basketItemIndex }) {
		state.basket.lines[basketItemIndex].quantity ++;
	},
	removeLineItemFromBasket (state, { basketItemIndex }) {
		state.basket.lines.splice( basketItemIndex, 1);
	},
	setAllLocations (state, { locations }) {
		state.allLocations = locations;
	},
	setBasket (state, { basket }) {
		state.basket = basket;
	},
	setBookingMeta (state, { name, email, siteId, dateTime, numPeople, bookingRef }) {
		state.booking.name = name
		state.booking.email = email
		state.booking.siteId = siteId
		state.booking.dateTime = dateTime
		state.booking.numPeople = numPeople
		state.booking.bookingRef = bookingRef
	},
	setError (state, { heading, message }) {
		state.error = { heading, message };
	},
	setLocation (state, { location }) {
		state.location = location;
	},
	setMenu (state, { label, menu }) {
		state.menus[label] = menu;
	},
	setMenuId (state, { foodMenuId, drinksMenuId }) {
		state.requiredSalesData.foodMenuId = foodMenuId;
		state.requiredSalesData.drinksMenuId = drinksMenuId;
	},
	setServiceId (state, { serviceId }) {
		state.requiredSalesData.serviceId = serviceId;
	},
	setTables (state, { tables }) {
		state.tables = tables
	},
	setTableNumber (state, { tableNumber }) {
		state.requiredSalesData.tableNumber = tableNumber;
	},
	setTillMessage (state, { messages }) {
		state.basket.lines.forEach((line) => {
			line.messages = messages;
		});
	},
	setSalesAreaId (state, { salesAreaId }) {
		state.requiredSalesData.salesAreaId = salesAreaId;
	},
	setUpsellModalDisplayed (state) {
		state.upsellModalDisplayed = true;
	},
	setValidVoucherApplied (state, { voucherDescription }) {
		state.validVoucherApplied = voucherDescription;
	},
	setZonalSiteId(state, { siteId }) {
		state.requiredSalesData.siteId = siteId
	},
 	setZonalVenueInfo(state, { restaurantData }) {
		state.iOrderLocation = restaurantData;
	}
};
